import React, { Children, useState } from "react";
import { cn } from "../../../utils/cn";
import { SearchResult } from "../../contexts/SearchResultsContext";
import ResultCard from "../search/ResultCard";

interface BentoGridProps extends React.HTMLAttributes<HTMLDivElement> {
  singleRow?: boolean;
}

const BentoGrid = React.forwardRef<
  HTMLDivElement,
  BentoGridProps
>(({ className, singleRow = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      singleRow 
        ? "flex gap-4 overflow-x-auto pb-4 scrollbar-hide" // Horizontal scrollable layout
        : "grid grid-cols-1 md:grid-cols-4 gap-4 max-w-7xl mx-auto", // Original grid layout
      className
    )}
    style={singleRow ? undefined : {
      gridAutoRows: '150px' // Fixed row height for grid layout
    }}
    {...props}
  />
));
BentoGrid.displayName = "BentoGrid";

const BentoGridItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    item: SearchResult;
    onTrack: (type: string) => void;
    singleRow?: boolean;
  }
>(({ className, item, onTrack, singleRow = false, ...props }, ref) => {
    return (
  <div
    ref={ref}
    className={cn(
      "rounded-xl group/bento hover:shadow-xl transition duration-200 border border-[var(--rhea-card-border)] bg-[var(--rhea-card-bg)] overflow-hidden",
      singleRow ? "flex-shrink-0 w-80 h-48" : "h-full", // Fixed width and height for single row items
      className
    )}
    {...props}
  >
    <ResultCard result={item} onTrack={onTrack}/>
  </div>
    )
});
BentoGridItem.displayName = "BentoGridItem";

export { BentoGrid, BentoGridItem }; 